<template>
  <v-layout justify-space-between align-content-start class="scroll">
    <v-container class="column-container download-col">
      <v-layout column align-center>
        <div class="substep-number mb-3">1</div>
        <div class="subheader mb-3"><strong>Download</strong></div>
        <div class="mb-3">
          <ul>
            <li>To get started we first recommend downloading the {{currentStep.charAt(0).toUpperCase() + currentStep.slice(1)}} template that shows you how to correctly structure your data</li>
          </ul>
        </div>
        <v-btn color="primary" @click="downloadTemplate">Download Template</v-btn>
        <br />
        <br />
        <img :src="'dist/images/' + currentStep + '-template.png'" width="100%" />
        <div class="example-text mt-2">Example {{currentStep.charAt(0).toUpperCase() + currentStep.slice(1)}} template</div>
      </v-layout>
    </v-container>
    <v-container class="column-container edit-col">
      <v-layout column align-center>
        <div class="substep-number mb-3">2</div>
        <div class="subheader mb-3"><strong>Edit</strong></div>
        <buildings-guidelines v-if="currentStep === 'buildings'" />
        <networks-guidelines v-if="currentStep === 'networks'" />
        <spaces-guidelines v-if="currentStep === 'spaces'" />
        <sensors-guidelines v-if="currentStep === 'sensors'" />
      </v-layout>
    </v-container>
    <v-container class="column-container upload-col">
      <v-layout column align-center>
        <div class="substep-number mb-3">3</div>
        <div class="subheader mb-3"><strong>Upload</strong></div>
        <div class="mb-3">
          <ul>
            <li>Save the file after editing with "{{currentStep.charAt(0).toUpperCase() + currentStep.slice(1)}}" as the file name and make sure the file format is in CSV form with UTF-8 encoding.</li>
            <li>Note that this upload acts as an “append” and not a replacement. If you were to have 100 {{ currentStep }} already then upload only 1 row with a new unique id field, you’d have 101 spaces after a successful upload.</li>
          </ul>
        </div>
        <v-btn color="primary" @click="upload">Ready to upload</v-btn>
      </v-layout>
    </v-container>
  </v-layout>
</template>
<script>
import BuildingsGuidelines from './BuildingsGuidelines';
import NetworksGuidelines from './NetworksGuidelines';
import SpacesGuidelines from './SpacesGuidelines';
import SensorsGuidelines from './SensorsGuidelines';

export default {
  name: 'startingGuide',
  props: {
    currentStep: {
      type: String,
      default: ''
    },
  },
  components: {
    BuildingsGuidelines,
    NetworksGuidelines,
    SpacesGuidelines,
    SensorsGuidelines
  },
  methods: {
    upload: function(event) {
      this.$emit('upload-clicked', event);
    },
    downloadTemplate: function(event) {
      this.$emit('download-clicked', event);
    }
  }
}
</script>
<style lang="scss" scoped>
.subheader {
  font-size: 16px;
}
.substep-number {
  border-radius: 50%;
  background:  #4D52E5;
  width: 40px;
  height: 40px;
  color: white;
  text-align: center;
  line-height: 40px;
  font-weight: 800;
  font-size: 20px;
}
.scroll {
  max-height: 500px;
  overflow-y: auto;
}
.column-container {
  margin-top: 0;
}
.download-col, .edit-col, .upload-col {
  max-width: 318px;
}
.example-text {
  font-size: 11px;
  font-style: italic;
}
</style>
